<ng-container *transloco="let t; prefix: 'orders.customerConfiguration'">
  <span class="create-customer-heading title-medium-emphasized">{{ t('manualCustomerTitle') }}</span>
  <form class="manual-customer-form" [formGroup]="form" (ngSubmit)="continue()">
    <div class="manual-customer-fields">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('companyName') }}</mat-label>
        <input matInput formControlName="ragioneSociale" autocomplete="organization" required>
        <mat-error>{{ t('requiredField') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('taxCode') }}</mat-label>
        <input matInput formControlName="codiceFiscale" maxlength="16" autocapitalize="characters" spellcheck="false" required>
        <mat-hint>{{ t('taxCodeHint') }}</mat-hint>
        <mat-error>{{ t('taxCodeError') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('vatNumber') }}</mat-label>
        <input matInput formControlName="partitaIva" maxlength="11" inputmode="numeric" required>
        <mat-hint>{{ t('vatNumberHint') }}</mat-hint>
        <mat-error>{{ t('vatNumberError') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('address') }}</mat-label>
        <input matInput formControlName="indirizzo" autocomplete="street-address" required>
        <mat-error>{{ t('requiredField') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('locality') }}</mat-label>
        <input matInput formControlName="localita" autocomplete="address-level2" required>
        <mat-error>{{ t('requiredField') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('province') }}</mat-label>
        <input matInput formControlName="provincia" maxlength="2" autocomplete="address-level1" required>
        <mat-error>{{ t('provinceError') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('postcode') }}</mat-label>
        <input matInput formControlName="cap" maxlength="5" inputmode="numeric" autocomplete="postal-code" required>
        <mat-error>{{ t('postcodeError') }}</mat-error>
      </mat-form-field>
    </div>
    <mat-checkbox formControlName="useAddressAsDestination">{{ t('useAddressAsDestination') }}</mat-checkbox>
    <div class="manual-customer-actions">
      <button matButton="filled" type="submit" [disabled]="form.invalid">{{ t('continue') }}</button>
    </div>
  </form>
</ng-container>
